import React from 'react';
import {
	PricingTableContent,
	HeaderCol,
	HeaderColHeadline,
	HeaderColPrice,
	HeaderColDescription,
	HeaderColButton,
	HeaderRow,
	PricingTableThead,
	PricingTableTh,
	PricingTableTbody,
	MobileTableList,
	MobileTableItem,
	MobileTableHeaderCol,
	MobileTableRow,
	PricingTableColTitle,
} from './PricingTable.dump';
import PricingTableCell from './PricingTableCell';
import classnames from 'classnames';

type PricingHeader = {
	package: string;
	price: string;
	text?: string;
	link: string;
	linkText: string;
};

export type PricingCell = boolean | string | { text: string; subtext: string };

export interface RowProps {
	name: string;
	available: PricingCell[];
}

export interface PricingTableProps {
	headers: PricingHeader[];
	rows: RowProps[];
	backgroundHeader?: string;
	backgroundBorder?: string;
}

const DesktopTable: React.FC<PricingTableProps> = ({
	headers,
	rows,
	backgroundHeader,
	backgroundBorder,
}) => {
	const theme = {
		backgroundHeader: backgroundHeader || '#202c33',
		backgroundBorder: backgroundBorder || '#1A1C29',
	};

	return (
		<PricingTableContent>
			<PricingTableThead theme={theme}>
				<tr>
					<PricingTableTh theme={theme} scope="col" />
					{headers.map((el, index) => {
						return (
							<PricingTableTh theme={theme} key={index}>
								<HeaderCol>
									<HeaderColHeadline>{el.package}</HeaderColHeadline>
									<HeaderColPrice>{el.price}</HeaderColPrice>
									{el.text && <HeaderColDescription>{el.text}</HeaderColDescription>}
									<HeaderColButton href={el.link}>{el.linkText}</HeaderColButton>
								</HeaderCol>
							</PricingTableTh>
						);
					})}
				</tr>
			</PricingTableThead>
			<PricingTableTbody theme={theme}>
				{rows.map((el, index) => {
					return (
						<tr key={index}>
							<HeaderRow theme={theme}>{el.name}</HeaderRow>
							{el.available.map((av, i) => {
								return (
									<PricingTableTh theme={theme} key={i}>
										<PricingTableCell cell={av} />
									</PricingTableTh>
								);
							})}
						</tr>
					);
				})}
			</PricingTableTbody>
		</PricingTableContent>
	);
};

const MobileTable: React.FC<PricingTableProps> = ({
	headers,
	rows,
	backgroundHeader,
	backgroundBorder,
}) => {
	const theme = {
		backgroundHeader: backgroundHeader || '#202c33',
		backgroundBorder: backgroundBorder || '#1A1C29',
	};

	return (
		<MobileTableList>
			{headers.map((el, index) => {
				return (
					<MobileTableItem theme={theme} key={index}>
						<MobileTableHeaderCol theme={theme}>
							<HeaderColHeadline>{el.package}</HeaderColHeadline>
							<HeaderColPrice>{el.price}</HeaderColPrice>
							{el.text && <HeaderColDescription>{el.text}</HeaderColDescription>}
							<HeaderColButton href={el.link}>{el.linkText}</HeaderColButton>
						</MobileTableHeaderCol>
						<div>
							{rows.map((row, ind) => (
								<MobileTableRow
									theme={theme}
									key={ind}
									className={classnames({ active: row.available[index] })}
								>
									<PricingTableColTitle>{row.name}</PricingTableColTitle>
									<PricingTableCell cell={row.available[index]} />
								</MobileTableRow>
							))}
						</div>
					</MobileTableItem>
				);
			})}
		</MobileTableList>
	);
};

const PricingTable: React.FC<PricingTableProps> = props => {
	return (
		<>
			<DesktopTable {...props} />
			<MobileTable {...props} />
		</>
	);
};

export default PricingTable;
